import superagent from 'superagent'

const methods = ['get', 'post', 'put', 'patch', 'del']

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError:
 * APIClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */
export default class APIClient {

  constructor(req, middlewares = []) {

    // reference to the request library for serverside stuff like
    // setting cookies
    this.req = req

    this.middlewares = middlewares

    methods.forEach((method) => {

      this[method] = (
        urlParam,
        optsParam = {},
        storeMiddlewares = []
      ) => {

        let request

        const promise = new Promise((resolve, reject) => {

          const opts = this.applyMiddlewares(
            'request',
            {
              // this contains `data` and (query) `params`
              ...{
                ...optsParam,
                method
              },
              url: urlParam,
              middlewares: storeMiddlewares,

            }
          )

          const { url, params, file } = opts
          let { data, headers } = opts

          const fn = this.createRequest(method)

          request = fn(url)

          if (params) {
            request.query(params)
          }

          if (method === 'del') {
            headers = headers || {}
            headers['Content-Type'] = ''
          }

          if (headers) {
            Object.keys(headers)
              .forEach((header) => request.set(header, headers[header]))
          }

          // if (opts.withCredentials) {
          request.withCredentials()
          // }

          // eslint-disable-next-line
          if (typeof __SERVER__ !== 'undefined' && __SERVER__ && req.get('cookie')) {
            request.set('cookie', req.get('cookie'))
          }

          if (
            (method === 'post'
              || method === 'put')
            && opts.contentType
            && opts.contentType === 'form-data'
          ) {

            const formData = new FormData()

            formData.append('json', JSON.stringify(data))

            if (file && file.length) {
              file
                .filter((f) => (f instanceof File))
                .forEach((singleFile) => {
                  formData.append(
                    singleFile.fieldName || file,
                    singleFile,
                    singleFile.name
                  )
                })
            }

            data = formData

            // It's actually not necessary (and advised) to set
            // the content type younself. It will be set
            // automatically when sending FormData.
            // request.type('multipart/form-data')

          }

          if (data) {
            request.send(data)
          }

          request.on('progress', (event) => {
            this.applyMiddlewares(
              'progress',
              {
                method,
                data,
                event,
                middlewares: storeMiddlewares,
              }
            )
          })

          request.end((errParam, resParam) => {

            let body = null

            const { res, err } = this.applyMiddlewares(
              'response',
              {
                res: resParam,
                err: errParam,
                middlewares: storeMiddlewares,
              }
            )

            if (res) {

              if (!res.body && res.text) {
                /* eslint-disable max-depth */
                try {
                  body = JSON.parse(res.text)
                }
                catch (ex) {
                  body = null
                }
                /* eslint-enable max-depth */
              }
              else {
                body = res.body
              }
            }

            return err
              ? reject(body || err)
              : resolve(body)

          })

        })

        promise.request = request
        return promise

      }

    })

  }

  clone() {
    return new this.constructor(this.req, this.middlewares)
  }

  createRequest(method) {
    return superagent[method]
  }

  use(middleware) {

    this.middlewares.push(middleware)

  }

  applyMiddlewares(type, opts) {

    return [
      ...this.middlewares,
      ...(opts.middlewares || []),
    ]
      .filter((middleware) => type in middleware
        && typeof middleware[type] === 'function')
      .reduce((memo, middleware) => {

        try {
          const retval = middleware[type](memo)
          return { ...memo, ...retval }
        }
        catch (ex) {
          // eslint-disable-next-line max-len
          console.log(`Middleware ${middleware.constructor.name}.${type} failed: ${ex.message}`)
          return memo
        }

      }, opts)

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/client.js